export class CrdtAlgorithmStandard {
    algoType = 'Standard';
}
export function isStandardCrdtAlgorithm(algo) {
    return algo.algoType === 'Standard';
}
//# sourceMappingURL=CrdtAlgorithmStandard.js.map